import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Row, Col, Tab, Tabs } from "react-bootstrap";
import moment from "moment";
import { Formik } from "formik";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import ErrorComponent from "../../Component/ErrorComponent";
import { CreateAssignemntSchema } from "../../utils/ValidationSchema";
import SelectStarModal from "../../Component/SelectStar";
import { useEffect } from "react";
import { GetFunction, SubmitResponse } from "../../utils/ApiFunctions";
import { useLocalization } from "../../Component/Localization/Localization";
import SelectMulipleUserForGrouip from "../../Component/SelectMulipleUserForGrouip";
import SelectPerson from "../../Component/SelectPerson";
import { GetValueLableWithId } from "../../utils/Helper";

import Select from "react-select";

// import SelectStar from "../Component/SelectStar"

const StaffTaskAndReminder = () => {
  const { assessmentType } = useParams();
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);

  const [schooList, setSchoolList] = useState([]);
  const [leavetypeList, setLeaveType] = useState([]);
  const [document, setDocument] = useState("");
  const [schoolId, setSchoolId] = useState("");
  const usr = localStorage.getItem("user_id");
  const [starmodal, setSlectStarModal] = useState(false);
  const [btnsState, setBtnState] = useState(false);
  const [stararraySelected, SetSelectStar] = useState([]);
  const [starNames, setSelectStartName] = useState([]);

  async function GetSchoolList() {
    const res = await GetFunction(`school/get/list?user=${usr}`);
    if (res.status == 200) {
      setSchoolList(res?.data?.data?.data);
    }
  }
  useEffect(() => {
    GetSchoolList();
  }, []);

  const handleSubmit = async (values) => {
    setBtnState(true);
    const data = new FormData();
    data?.append("school", values?.school);
    data?.append("title", values?.title);
    data?.append("assignmentNo", values?.assignmentno);
    data?.append("type", values.assigntype);
    for (let i = 0; i < stararraySelected?.length; i++) {
      data?.append(`assignTo[${i}]`, stararraySelected[i]?._id);
    }

    data?.append("postDate", values?.postdate);
    data?.append("postTime", moment(values?.posttime).format("HH:mm:ss"));

    data?.append("dueDate", values?.duedate);

    data?.append("submitTime", moment(values?.submitTime).format("HH:mm:ss"));
    data?.append("submitDate", values?.submitDate);
    data?.append("dueTime", moment(values?.duetime).format("HH:mm:ss"));

    if (values.link) {
      data?.append("link", values?.link);
    }
    if (values.description) {
      data?.append("description", values?.description);
    }

    if (document) {
      data?.append("document", document);
    }

    const res = await SubmitResponse(`assignments/assign_assignment`, data);
    if (res.status == 200) {
      toast.success(res?.data?.message);
      navigate(`/Assignment/${assessmentType}`);
      setBtnState(false);
    } else {
      setBtnState(false);
    }
  };

  const { t } = useLocalization();
  useEffect(() => {
    setOptions(GetValueLableWithId(schooList, ["_id", "name"]));
  }, [schooList]);

  const optionsArray = [
    { value: "", label: `${t("assign_type")}:` },
    { value: "awarenessCourses", label: t("awareness_courses") },
    { value: "worksheet", label: t("worksheet") },
    // { value: "assessment", label: t("assessment") },
    // { value: "lab", label: t("lab") },
  ];
  return (
    <>
      <div id="main" className="main-section-login">
        <section className="">
          <div className="section-heading plage-steps-dtl my-2 ">
            <h2 className="performance-heading">
              {/* Add{" "}
               */}

              {assessmentType == "awarenessCourses"
                ? t("awareness_courses")
                : t(assessmentType)}
            </h2>
          </div>

          <section className="profile-aection bg-light p-3">
            <Row className="mt-2">
              <Col md={8}>
                <Formik
                  initialValues={{
                    school: "",
                    title: "",
                    postdate: "",
                    posttime: "",
                    assigntype: "",
                    assignmentno: "",
                    description: "",
                    submitTime: "",
                    submitDate: "",
                    duedate: "",
                    duetime: "",
                    link: "",
                  }}
                  onSubmit={handleSubmit}
                  validationSchema={CreateAssignemntSchema}
                  enableReinitialize
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    setFieldValue,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <form
                      className="cmn-frm without-icon add-filds"
                      onSubmit={handleSubmit}
                    >
                      <Row>
                        <Col md={12}>
                          <div className="form-group">
                            {/* <select
                              className="form-control"
                              onChange={(e) => {
                                setSchoolId(e.target.value);
                                handleChange(e);
                              }}
                              value={values.school}
                              name="school"
                            >
                              <option selected value="" disabled>
                                {t("select_school")}
                              </option>
                              {schooList &&
                                schooList?.map((val, i) => (
                                  <option value={val?._id}>{val?.name}</option>
                                ))}
                            </select> */}
                            <Select
                              placeholder={t("select_school")}
                              options={options}
                              name="school"
                              onChange={(option) => {
                                handleChange({
                                  target: {
                                    name: "school",
                                    value: option ? option.value : "",
                                  },
                                });
                                setSchoolId(option.value);
                              }}
                              value={options.find(
                                (option) => option.value === values.school
                              )}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.school && touched.school && errors.school
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            <div
                              className="select-star"
                              onClick={() => {
                                if (values.school) {
                                  setSlectStarModal(true);
                                } else {
                                  toast.error("Please Select School First");
                                }
                              }}
                            >
                              {stararraySelected &&
                                // stararraySelected?.map((val) => (
                                //   <span>{val?.name} </span>
                                // ))
                                starNames?.join(",")}

                              {stararraySelected?.length >= 1
                                ? ""
                                : t("select_assgin_to")}
                            </div>
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            <input
                              type="text"
                              name="title"
                              placeholder={t("title")}
                              onChange={handleChange}
                              value={values.title}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.title && touched.title && errors.title
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            {/* <select
                              onChange={handleChange}
                              value={values.assigntype}
                              name="assigntype"
                            >
                              <option value="" defaultValue>
                                {t("assign_type")}:
                              </option>
                              <option value="awarenessCourses">
                                {t("awareness_courses")}
                              </option>
                              <option value="worksheet">
                                {t("worksheet")}
                              </option>
                              <option value="assessment">
                                {t("assessment")}
                              </option>
                              <option value="lab">{t("lab")}</option>
                            </select> */}

                            <Select
                              placeholder={t("assign_type")}
                              options={optionsArray}
                              onChange={(option) => {
                                handleChange({
                                  target: {
                                    name: "assigntype",
                                    value: option ? option.value : "",
                                  },
                                });
                              }}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999, // Set the desired z-index value
                                  padding: "5px",
                                }),
                                control: (provided) => ({
                                  ...provided,
                                  borderColor: "#AEAEAE", // Set border color to #AEAEAE
                                  "&:hover": {
                                    borderColor: "#AEAEAE", // Set border color when hovering
                                  },
                                  padding: "8px",
                                }),
                              }}
                              value={optionsArray.find(
                                (option) => option.value === values.assigntype
                              )}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.assigntype &&
                              touched.assigntype &&
                              errors.assigntype
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            <input
                              type="text"
                              name="assignmentno"
                              placeholder={t("assignment_no")}
                              onChange={handleChange}
                              value={values.assignmentno}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.assignmentno &&
                              touched.assignmentno &&
                              errors.assignmentno
                            }
                          />
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <DatePicker
                              name="postdate"
                              value={values.postdate}
                              minDate={new Date()}
                              placeholderText={t("assignment_date")}
                              onChange={(date) =>
                                setFieldValue(
                                  "postdate",
                                  moment(date).format("YYYY-MM-DD")
                                )
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Backspace") {
                                  values.postdate = "";
                                } else {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.postdate &&
                              touched.postdate &&
                              errors.postdate
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            <DatePicker
                              name="posttime"
                              placeholderText={t("assignment_time")}
                              selected={
                                values?.posttime ? values?.posttime : ""
                              }
                              onChange={(posttime) =>
                                setFieldValue("posttime", posttime)
                              }
                              showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={10}
                              timeCaption="Time"
                              dateFormat="h:mm:ss aa"
                              onKeyDown={(e) => {
                                if (e.key === "Backspace") {
                                  values.posttime = "";
                                } else {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.posttime &&
                              touched.posttime &&
                              errors.posttime
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            <DatePicker
                              name="submitDate"
                              minDate={new Date()}
                              value={values.submitDate}
                              placeholderText={t("submit_date")}
                              onChange={(date) =>
                                setFieldValue(
                                  "submitDate",
                                  moment(date).format("YYYY-MM-DD")
                                )
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Backspace") {
                                  values.submitDate = "";
                                } else {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.submitDate &&
                              touched.submitDate &&
                              errors.submitDate
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            <DatePicker
                              name="submitTime"
                              placeholderText={t("submit_time")}
                              selected={
                                values?.submitTime ? values?.submitTime : ""
                              }
                              onChange={(time) =>
                                setFieldValue("submitTime", time)
                              }
                              showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={10}
                              timeCaption="Time"
                              dateFormat="h:mm:ss aa"
                              onKeyDown={(e) => {
                                if (e.key === "Backspace") {
                                  values.submitTime = "";
                                } else {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.submitTime &&
                              touched.submitTime &&
                              errors.submitTime
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            <DatePicker
                              name="duedate"
                              value={values.duedate}
                              minDate={new Date()}
                              placeholderText={t("due_date")}
                              onChange={(date) =>
                                setFieldValue(
                                  "duedate",
                                  moment(date).format("YYYY-MM-DD")
                                )
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Backspace") {
                                  values.duedate = "";
                                } else {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.duedate &&
                              touched.duedate &&
                              errors.duedate
                            }
                          />
                        </Col>

                        <Col md={6}>
                          <div className="form-group">
                            <DatePicker
                              name="duetime"
                              placeholderText={t("due_time")}
                              selected={values?.duetime ? values?.duetime : ""}
                              onChange={(time) =>
                                setFieldValue("duetime", time)
                              }
                              showTimeSelect
                              showTimeSelectOnly
                              timeIntervals={10}
                              timeCaption="Time"
                              dateFormat="h:mm:ss aa"
                              onKeyDown={(e) => {
                                if (e.key === "Backspace") {
                                  values.duetime = "";
                                } else {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>
                          <ErrorComponent
                            error={
                              errors.duetime &&
                              touched.duetime &&
                              errors.duetime
                            }
                          />
                        </Col>

                        {assessmentType == "worksheet" && (
                          <Col md={12}>
                            <div className="form-group">
                              <textarea
                                placeholder={t("description")}
                                name="description"
                                value={values.description}
                                onChange={handleChange}
                              ></textarea>
                            </div>
                            <ErrorComponent
                              error={
                                errors.description &&
                                touched.description &&
                                errors.description
                              }
                            />
                          </Col>
                        )}

                        {assessmentType != "worksheet" && (
                          <Col md={12}>
                            <div className="form-group">
                              <input
                                type="file"
                                onChange={(e) => setDocument(e.target.files[0])}
                              />
                            </div>
                          </Col>
                        )}

                        {assessmentType != "worksheet" && (
                          <>
                            <Col md={6}>
                              <div className="form-group">
                                <input
                                  type="text"
                                  name="link"
                                  placeholder={t("link")}
                                  onChange={handleChange}
                                  value={values.link}
                                />
                              </div>
                              <ErrorComponent
                                error={
                                  errors.link && touched.link && errors.link
                                }
                              />
                            </Col>
                            <Col md={6}></Col>
                          </>
                        )}
                        <Col md={6}>
                          <div>
                            <button
                              disabled={btnsState}
                              className="btn-btn-primary px-5"
                              type="submit"
                            >
                              {t("save")}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  )}
                </Formik>
              </Col>
            </Row>
          </section>
        </section>
      </div>
      {/* <SelectStarModal
        show={starmodal}
        onHide={() => setSlectStarModal(false)}
        Selectdata={(data) => {
          SetSelectStar(data);
        }}
        prevoiusdata={stararraySelected}
      /> */}

      <SelectPerson
        schoolId={schoolId}
        show={starmodal}
        defaultRole={"teacher"}
        onHide={() => setSlectStarModal(false)}
        Selectdata={(data) => {
          SetSelectStar(data);
          const names = data?.map((person) => person.name);
          setSelectStartName(names);
        }}
        prevoiusdata={stararraySelected}
      />
    </>
  );
};

export default StaffTaskAndReminder;
